import React from 'react';
import { TouchableOpacity, ActivityIndicator } from 'react-native';
import Colors from '../constants/colors';
import { View } from './Themed';


type SwitchProps = { 
    value: boolean, 
    switch_type: 'binary' | 'on_off', 
    disabled?:boolean,
    size?:number,
    loading?:boolean,
    onChange:(value:boolean) => void 
}
const Switch = ({ value, disabled, size, switch_type, loading, onChange }:SwitchProps) => {

    const handleChange = () => {
        if(onChange){
            onChange(!value)
        }
    }

    const dot_size = size ?? 18
    const switch_size = dot_size + 6
    const switch_width = switch_size * 2

    return (
        <View transparent style={{ flexDirection:'row', alignItems:'flex-start' }}>
            {switch_type == 'on_off' ?
            <TouchableOpacity 
            disabled={disabled}
            style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center', backgroundColor:value?Colors.highlights.highlight400:Colors.brand.slate, padding:3, borderRadius:12, width:switch_width,height:switch_size}} onPress={() => handleChange()}>
            { value ? 
                <>
                <View transparent />
                <View transparent style={{ borderRadius:100, width:dot_size, height:dot_size, backgroundColor:Colors.shades.white}} />
                </>
            :
                <>
                <View transparent style={{ borderRadius:100, width:dot_size, height:dot_size, backgroundColor:Colors.shades.white}} />
                <View/>
                </>
            }
        </TouchableOpacity>
        :
        <TouchableOpacity 
        disabled={disabled}
        style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center', backgroundColor:Colors.shades.white, padding:3, borderRadius:12, width:switch_width,height:switch_size}} onPress={() => handleChange()}>
            { value ? 
                <>
                <View />
                <View transparent style={{ borderRadius:100, width:dot_size, height:dot_size, backgroundColor:Colors.highlights.highlight400}} />
            </>
            :
            <>
                <View transparent style={{ borderRadius:100, width:dot_size, height:dot_size, backgroundColor:Colors.highlights.highlight400}} />
                <View />
            </>
            }
        </TouchableOpacity>
        }
        {loading ?
        <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center', alignItems:'center' }}>
            <ActivityIndicator size='small' color={Colors.shades.white}/>
        </View>
        :<></>}
        </View>
    )
}


export default Switch